type AnyFunction = (...args: any[]) => any;
export const debounce = (functionToDebounce: AnyFunction, timeout: number) => {
  let timeoutId: ReturnType<typeof setTimeout>;

  return (...args: any[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => functionToDebounce(...args), timeout);
  };
};
